import { connect } from 'react-redux';
import OrganizationSettings from './components/OrganizationSettings';
import {
  updateOrganization,
  loadUsers,
  loadMySubscriptionPlan,
  loadOrganization,
} from '../../redux/actions/user';
import {
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
  loadSlack,
  saveSlack,
  updateSlack,
  deleteSlack,
  loadMTeams,
  saveMTeams,
  updateMTeams,
  deleteMTeams,
} from '../../redux/actions/integrations';
import { loadAPIAccess } from '../../redux/actions/APIAccess';

const mapStateToProps = (state) => ({
  splunkSettings: state.integration.splunkSettings,
  slackSettings: state.integration.slackSettings,
  mTeamsSettings: state.integration.mTeamsSettings,
  user: state.user.user,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  updateOrganization,
  loadOrganization,
  loadSlack,
  saveSlack,
  updateSlack,
  deleteSlack,
  loadMTeams,
  saveMTeams,
  updateMTeams,
  deleteMTeams,
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
  loadUsers,
  loadAPIAccess,
  loadMySubscriptionPlan,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationSettings);
